import React, { createContext, useContext, useEffect, useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'

const VolunteeringExerciseContext = createContext()

const useVolunteeringExercise = () => {
  return useContext(VolunteeringExerciseContext)
}

const VolunteeringExerciseProvider = ({
  section,
  getResponse,
  trackContent,
  children,
}) => {
  const { t } = useTranslation('volunteering')
  const { setContinueButtonDisabled } = useExercise()
  const pageOneTranslations = t('pages.0')
  const pageTwoTranslations = t('pages.1')
  const goals = pageOneTranslations.goals
  const initialGoals =
    trackContent[0]?.rankedGoals ||
    goals.map((goal) => ({
      ...goal,
      rank: goal.rank ? parseInt(goal.rank) : null,
    }))
  const [rankedGoals, setRankedGoals] = useState(initialGoals)

  useEffect(() => {
    setContinueButtonDisabled(rankedGoals.some((goal) => goal.rank === null))
  }, [rankedGoals, setContinueButtonDisabled])

  const value = {
    section,
    getResponse,
    trackContent,
    rankedGoals,
    goals,
    pageOneTranslations,
    setRankedGoals,
    pageTwoTranslations,
  }

  return (
    <VolunteeringExerciseContext.Provider value={value}>
      {children}
    </VolunteeringExerciseContext.Provider>
  )
}

export { VolunteeringExerciseProvider, useVolunteeringExercise }
